import {
  HeadingLarge,
  HeadingXSmall,
  ParagraphMedium,
} from "@mezo-org/mezo-clay"

import {
  selectReferralCodes,
  selectTotalMats,
  useDappSelector,
} from "#/redux-state"

import MatsEmptyState from "./MatsEmptyState"
import MatsInvites from "./MatsInvites"
import MatsStats from "./MatsStats"

export default function MatsDashboard() {
  const referralCodes = useDappSelector(selectReferralCodes)
  const totalMats = useDappSelector(selectTotalMats)

  if (!totalMats) return <MatsEmptyState />

  return (
    <>
      <HeadingLarge marginBottom="scale600">Your mats overview</HeadingLarge>
      <MatsStats />
      {referralCodes && referralCodes.length > 0 && (
        <>
          <HeadingXSmall>
            Give your friends early access, get up to a 3x mats boost.
          </HeadingXSmall>
          <ParagraphMedium marginBottom="scale1000" color="contentSecondary">
            Invite your friends to Mezo to earn more together. Codes are
            single-use.
          </ParagraphMedium>
          <MatsInvites />
        </>
      )}
    </>
  )
}
